import { streamScenes } from "@/mocks/gossip";
import SectionHeading from "./SectionHeading";

const tagTone: Record<string, string> = {
  LIVE: "bg-accent-500 text-background-50",
  REPLAY: "bg-secondary-500 text-background-50",
  COMING: "bg-primary-500 text-background-50",
};

export default function StreamScene() {
  return (
    <section id="scene" className="relative overflow-hidden bg-background-950 py-16 md:py-24">
      <div className="pointer-events-none absolute -right-24 top-10 h-72 w-72 rounded-full bg-primary-500/15 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-24 bottom-10 h-72 w-72 rounded-full bg-accent-500/15 blur-3xl"></div>

      <div className="relative mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <SectionHeading
          eyebrow="连麦开撕 · 现场直击"
          title="名场面直播间，正在连麦中"
          desc="主播带你直击连麦现场的火药味，看当事人开撕、回应、正面刚。开播信息与回放入口都给你放好了。"
          theme="dark"
        />

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {streamScenes.map((s, idx) => (
            <article
              key={s.id}
              className="group flex flex-col overflow-hidden rounded-3xl border border-background-50/10 bg-background-800/40 transition-transform duration-300 hover:-translate-y-1.5"
            >
              <div className="relative aspect-[4/5] w-full overflow-hidden">
                <img
                  src={s.img}
                  alt={`${s.host}：${s.title}直播现场`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-x-0 top-0 flex items-center justify-between p-4">
                  <span
                    className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold tracking-wider ${tagTone[s.tag]}`}
                  >
                    <i className={s.tag === "LIVE" ? "ri-radio-2-line chigua-pulse" : "ri-play-circle-line"}></i>
                    {s.tag}
                  </span>
                  <span className="rounded-full bg-black/55 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
                    {s.host}
                  </span>
                </div>
                <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/70 to-transparent"></div>
                <p className="absolute bottom-3 left-4 right-4 inline-flex items-center gap-2 text-xs text-background-50/95">
                  <i className="ri-group-line"></i>
                  {s.viewers}
                </p>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-background-50 md:text-xl">{s.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-6 text-background-50/70">{s.desc}</p>
                <div className="mt-5 flex items-center justify-between">
                  <span className="inline-flex items-center gap-1.5 text-xs font-medium text-background-50/60">
                    <i className="ri-calendar-check-line"></i>
                    {s.next}
                  </span>
                  <a
                    href="#top"
                    className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-50/10 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-500"
                  >
                    {s.tag === "COMING" ? "预约占座" : s.tag === "LIVE" ? "进直播间" : "看回放"}
                    <i className="ri-arrow-right-line"></i>
                  </a>
                </div>
              </div>
            </article>
          ))}
        </div>

        {/* featured note */}
        <p className="mt-10 text-center text-xs leading-6 text-background-50/50">
          * 直播与回放内容均来自公开平台整理，涉及多位当事人，请理性观看、文明吃瓜。
        </p>
      </div>
    </section>
  );
}